'use client'

import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { queryClient } from '@/lib/react-query'
import { useAiDock } from '@/lib/ai-dock/ai-dock.store'
import { ReactNode } from 'react'

interface QueryProviderProps {
  children: ReactNode
}

/**
 * Botão redondo do React Query DevTools (só em desenvolvimento). Fica fora do painel da IA do sinistro: com o painel
 * encaixado, à esquerda dele (ao lado do botão de bug); com o painel por cima (folha lateral ou mobile), some — no
 * canto de baixo à direita ele cobria o botão de enviar do chat.
 */
function DevtoolsButton() {
  const dock = useAiDock()
  if (dock.open && dock.mode !== 'push') return null
  return (
    <div className="fixed bottom-4 right-[calc(var(--ai-dock-w,0px)+4.25rem)] z-40">
      <ReactQueryDevtools initialIsOpen={false} buttonPosition="relative" />
    </div>
  )
}

export function QueryProvider({ children }: QueryProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {process.env.NODE_ENV === 'development' && <DevtoolsButton />}
    </QueryClientProvider>
  )
}

export default QueryProvider
